<template>
  <div style="display: flex;align-items: center">
    <auto-number-input
      v-model="job.quantityContract"
      :precision="0"
      :min="0"
      :disabled="disabled"
      @change="onChange('quantityContract')"
    />
    <span style="padding:0 2px;">/</span>
    <auto-number-input
      v-model="job.quantityActual"
      :precision="0"
      :disabled="disabled"
      :min="0"
      @change="onChange('quantityActual')"
    />
    <span style="min-width: 50px;">PCS</span>
  </div>
</template>

<script>
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'

export default {
  name: 'SeQuantityConsignActual',
  components: {
    AutoNumberInput
  },
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
